import InquiryPlainTextCell from './InquiryPlainTextCell';

interface PreliminaryDiagnosisCellProps {
  inquiryId: string;
  preliminaryDiagnosis: string;
}

const PreliminaryDiagnosisCell = ({
  inquiryId,
  preliminaryDiagnosis,
}: PreliminaryDiagnosisCellProps) => {
  return (
    <InquiryPlainTextCell id={`${inquiryId}__preliminary-diagnosis`}>
      {preliminaryDiagnosis}
    </InquiryPlainTextCell>
  );
};
export default PreliminaryDiagnosisCell;
